module.exports = __webpack_public_path__ + "img/got-milk.72cf1f19.png";